import styled from 'styled-components';

const BtnBox = styled.div`
    display: flex;
    margin-top: 30px;
`;

export default BtnBox;
